import { useCallback, useEffect, useMemo } from 'react';

import StatCard from '../../components/stats/StatCard';
// import StatLoader from './StatLoader';

import { useAppDispatch, useAppSelector } from '../../store/hooks';

import { getLostLeasesStats } from '../../store/stats/stats-slice';

interface LostLeasesProps {
  propertyID: string;
}

// dev only - remove when API is ready
const defaultData = {
  title: 'Net Leases',
  barData: {
    value: 0,
    total: 0
  },
  topData: {
    label: 'YTD Goal',
    value: 0
  },
  bottomData: {
    label: 'YTD Variance',
    value: 0
  }
};

const LostLeases = ({ propertyID }: LostLeasesProps): ReactNode => {
  const dispatch = useAppDispatch();
  const lostLeases: any = useAppSelector((state) => state.stats.lostLeases);
  const tour: any = useAppSelector((state) => state.stats.tours);
  const tourConversion: any = useAppSelector((state) => state.stats.tourConversion);
  const leases: any = useAppSelector((state) => state.stats.leases);

  const selectedPropertyData = useMemo(() => {
    if (tour.isLoading || tourConversion.isLoading || lostLeases.isLoading || lostLeases.data.length === 0) {
      return defaultData;
    }

    if (!propertyID && !lostLeases.isLoading && lostLeases.data.length > 0) {
      return defaultData;
    }

    const selectedData = lostLeases.data.find(
      (property: any) => property.PropertyID === propertyID
    );

    if (!selectedData) {
      return defaultData;
    }

    const multiplier = (
      Number(tourConversion?.data?.[0]?.goal_ratio ?? 0) *
      Number(lostLeases?.data?.[0]?.net_leases_percentage ?? 0)
    ) / 100;

    return {
      title: "Net Leases",
      barData: {
        value: Number(leases?.data?.[0]?.NetLeases ?? 0),
        total: Math.round(
          Number(tour?.data?.[0]?.annual_goal ?? 0) * multiplier
        ),
      },
      topData: {
        label: "YTD Goal",
        value: Math.round(
          Number(tour?.data?.[0]?.ytd_tour_goal ?? 0) * multiplier
        ),
      },
      bottomData: {
        label: "YTD Variance",
        value: 
          Number(leases?.data?.[0]?.NetLeases ?? 0) -
          Math.round(
            Number(tour?.data?.[0]?.ytd_tour_goal ?? 0) * multiplier
          ),
      },
    };
  }, [propertyID, tour, tourConversion, lostLeases]);

  const fetchData = useCallback(async () => {
    try {
      if (!propertyID) {
        return;
      }

      await dispatch(getLostLeasesStats(propertyID));
    } catch (error) {
      console.log('error:', error);
    }
  }, [dispatch, propertyID]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      {/* <StatLoader isLoading={lostLeases.isLoading} /> */}
      <StatCard
        data={selectedPropertyData ? selectedPropertyData : defaultData}
      />
    </>
  );
};

export default LostLeases;
